package io.jsonize.web.services

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag
import kotlin.js.Promise

actual suspend fun copyToClipboard(text: String): Boolean {
    val navigator = window.navigator.asDynamic()
    val clipboard = navigator.clipboard
    val writeText = clipboard?.writeText
    return if (writeText != null) {
        try {
            (writeText.call(clipboard, text) as Promise<*>).await()
            true
        } catch (_: dynamic) {
            false
        }
    } else {
        false
    }
}

actual suspend fun downloadTextFile(filename: String, content: String): String? {
    val safeName = filename.trim().ifEmpty { "generated.txt" }
    val blob = Blob(arrayOf(content), BlobPropertyBag(type = "text/plain;charset=utf-8"))
    val url = URL.createObjectURL(blob)

    val anchor = document.createElement("a") as HTMLAnchorElement
    anchor.href = url
    anchor.download = safeName
    anchor.style.display = "none"
    document.body?.appendChild(anchor)
    anchor.click()
    document.body?.removeChild(anchor)
    URL.revokeObjectURL(url)
    return null
}
